/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react'
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
  } from "@/components/ui/resizable"
  import { useQuery } from "@tanstack/react-query";
// import getUserData from './getUserData';
// import UserDataTable from './UserDataTable';
// import UserSelectedDetails from './UserSelectedDetails';
import { Bold } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Sheet from '../common/Sheet';
import SheetForm from '../common/Sheet';
import getUserData from './getUserData';
import { DataTableDemo } from './UsersDataTable';
import UserEditForm from './UserEditForm';
import UserSelectedDetails from './UserSelectedDetails';
import UserCreateForm from './UserCreateForm';
// import UserCreateForm from './UserCreateForm';


export default function UsersComp({isOpen}) {
    const [selected, setSelected] = React.useState(null)

    const [addUserSheet, setAddUserSheet] = React.useState(false)

    const { data: users, isFetching: isUserFetching } = useQuery({
		queryKey: ["User"],
		queryFn: getUserData,
		refetchIntervalInBackground: true,
		refetchInterval: 300000,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
	});

    
    const createUser = async () => {
        try {
            console.log('creating')
        } catch (error) {
            console.log(error)
        }
    }

  return (
    <div style={{width:'100%'}}>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <h2 style={{fontWeight: 'bolder'}} className='text-xl'>User Details</h2>
            <Button onClick={() => setAddUserSheet(true)}>+ Add User</Button>
        </div>
        
        <div className='mt-[2vh] rounded h-[83vh] '>
            <ResizablePanelGroup
                direction="horizontal"
                className={`max-w-md rounded-lg border ${isOpen ? 'min-w-[80vw]' : 'min-w-[94vw]'}`}
                
                >
                <ResizablePanel defaultSize={50} minSize={40}>
                    {/* <UserDataTable 
                        selected={selected} 
                        setSelected={setSelected} 
                        UserData={User} 
                        isUserFetching={isUserFetching}
                    /> */}
                    <DataTableDemo userData={users} setSelected={setSelected} />
                </ResizablePanel>
                <ResizableHandle withHandle />
                <ResizablePanel defaultSize={50} minSize={50}>
                    {/* <UserSelectedDetails 
                        selected={selected} 
                        setSelected={setSelected} 
                    /> */}
                    <UserSelectedDetails selected={selected} setSelected={setSelected}/>
                </ResizablePanel>
            </ResizablePanelGroup>
        </div>


        <SheetForm 
            open={addUserSheet}
            close={setAddUserSheet}
            title="Add User"
            description="Create a new User/Clinic"
            component={<UserCreateForm setAddUserSheet={setAddUserSheet}/>}
            action={createUser}

            // setOpen={setAddUserSheet}
        />
        
    </div>
  )
}
